import {BaseFormModel} from './base-form-model';

export class UserNotificationSummary extends BaseFormModel<UserNotificationSummary> {
    unread: number;
    unusedCredits: number;
    unseenNotifications: number;
}
